import React, { useContext } from 'react';

import { CardListSkeleton } from '@eika-kortbetjening/card-list-panel';
import { ErrorCard } from '@eika/card';
import { LinkList } from '@eika/link-list';

import CardControlContext from '@/context/card-control/CardControlContext';
import { useCard } from '@/react-query/hooks/query/use-card';
import { useCardSpendingLimits } from '@/react-query/hooks/query/use-spending-limits';

import useText from '@hooks/use-text';

import { SpendingLimitCategory } from '../types';
import { Setting } from './Setting';
import { SpendingLimitCategoryLink } from './SpendingLimitCategoryLink';
import { SettingInfo } from './modals/InfoModal';

export const SpendingLimitsSettings = () => {
    const text = useText();
    const { selectCategory, selectInfoModal } = useContext(CardControlContext);
    const { data: spendingLimits, isLoading: isLoadingSpendingLimits, isError } = useCardSpendingLimits();

    const { data: card } = useCard();

    if (isError) {
        return <ErrorCard title={text.spendingLimitFetchError} />;
    }

    if (!card?.allowedOperations.getSpendingLimit) {
        return null;
    }

    if (isLoadingSpendingLimits || typeof spendingLimits === 'undefined') {
        return <CardListSkeleton panelCount={2} />;
    }

    return (
        <Setting title={text.spendingLimitsLabel} onInfoClick={() => selectInfoModal(SettingInfo.SpendingLimits)}>
            <LinkList>
                <SpendingLimitCategoryLink
                    description={text.spendingLimitsLabelDaily}
                    limit={spendingLimits.card?.daily}
                    onClick={() => selectCategory(SpendingLimitCategory.DailyLimit)}
                />
                <SpendingLimitCategoryLink
                    description={text.spendingLimitsLabelMonthly}
                    limit={spendingLimits.card?.monthly}
                    onClick={() => selectCategory(SpendingLimitCategory.MonthlyLimit)}
                />
            </LinkList>
        </Setting>
    );
};
